export const DropdownArrowUp = () => (
    <svg width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.55803 0.569829C5.0764 -0.189943 3.9236 -0.189943 3.44197 0.569829L0.0134957 5.97822C0.0089051 5.98546 0.00440672 5.99272 0 6H9C8.99559 5.99272 8.99109 5.98546 8.9865 5.97822L5.55803 0.569829Z"
            fill="white"
        />
    </svg>
);
